import {
  ITINERARY_ID_PLACEHOLDER,
  RESULT_INDEX,
} from '@web-platform/shared-universal-constants/src/routes';
import translatedRoutes from '@web-platform/shared-universal-constants/src/routesTranslated.json';

/*
URL definitions and regex are spread across several key systems at Skyscanner. Care should be taken when adding, updating, or removing any URL.

Requests pass through:
  - CDN (CloudFront)
  - Public Gateway (k8s/Istio)
  - Request Handler (Nginx)
  - Banana server (Express)
  - Banana webapp (React Router)

The URL Management Service (UMS) also plays a key part, a service that stores URL schemas for lookup and generation of URLs.

Each service should be evaluated if making a change to ensure there are no side effects. The order of which service should be updated here matters - what a request hits first.

A good example of this going wrong was the change from hash routes to non-hash routes in this incident: https://skyscanner.atlassian.net/l/cp/en90Tj7w.

Additional reading can be found in [CloudFront to Banana](https://skyscanner.atlassian.net/l/cp/FaPvgBvS) and the [UMS documentation](https://skyscanner.atlassian.net/l/cp/5yXVVh4A)

If in doubt please reach out for wider peer review from engineers who own the above services.
*/

const { SEARCH_WITH_AI, TRANSPORTS } = translatedRoutes;
export { TRANSPORTS, SEARCH_WITH_AI };

export const ROOT = '/';

// helper constants — DETAILS, ITINERARY_ID_PLACEHOLDER and RESULT_INDEX live in
// universal so universal code can build the same hash-route patterns without
// depending on banana packages.
export { DETAILS } from '@web-platform/shared-universal-constants/src/routes';
export { ITINERARY_ID_PLACEHOLDER, RESULT_INDEX };
export const PLACE_LOCATION_RESULT_ID = ':placeLocationResultId';

// todo JUNO-280 replace temporary bifm hash route structure with a unified /BIFM page
// Hash Routes
export const BIFM_HASH = `#/bifm/${ITINERARY_ID_PLACEHOLDER}`;
export const COMBINED_RESULTS_SEARCH = '#/combined-results-search';
export const ITINERARY_PANEL = `#/itinerary-panel/${ITINERARY_ID_PLACEHOLDER}/index/${RESULT_INDEX}`;
export const FILTER_DRAWER = '#/filters';
export const RESULTS = '#/results';
export const SORT_DRAWER = '#/sort';
